export default "__VITE_ASSET__DAWhuG9M__"